
const week = ['周日','周一','周二','周三','周四','周五','周六'];
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: "home",
directives: {
TransferDom
},
components: {
Confirm
},
data () {
return {
height:window.innerHeight-50,
dateGoodsStatusWidth:100,
dateGoodsStatusWidthPad:30,
showDataList: [],
today: null,
calendar:[],
tuanGoodsList:[],
goodsAndCalendar: [],
daysStep: 10, //每次读取10天的价格日历
statusShow: false,
editForm: null,
blockDateLeft: 100,
loadedLastDate: null,
loadingMoreLock:false,
};
},
methods:{
initShowData(shopId)
{


var d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var Step = this.daysStep
this.calendar = []
this.createcalendarData(year, month, day, Step);

this.createGoodsAndCalendar(shopId,year, month, day,Step)
console.log(this.goodsAndCalendar)
},
createcalendarData: function (year, month, day, Step) {


this.dateGoodsStatusWidth = this.daysStep*70;

let d = new Date(year, month, day);
for (let j = 1; j <= Step; j++) {
this.calendar.push({
'year': d.getFullYear(),
'month': (d.getMonth()+1),
'day': d.getDate(),
'week': week[d.getDay()]
})
d = new Date(year, month, day+j);
}
},
initTuanGoodsList: function (shopId) {
let _this = this;
_this.axios.get('/v1/shop/'+shopId+'/status/rooms', null, {
headers: {}
}).then(function (response) {

_this.tuanGoodsList = response.data.data
}).catch(function (response) {
console.log(response);
});
},
createGoodsAndCalendar: function (shopId,year, month, day,Step) {
let _this = this;
_this.axios.get('/v1/shop/'+shopId+'/status?startTime='+year+'-'+(month+1)+'-'+day+'&step='+Step, null, {
headers: {}
}).then(function (response) {
console.log(response.data);
var statusResult = [];
statusResult = response.data.data;
var rs = [];

for (let i = 0; i < _this.tuanGoodsList.length; i++){
rs[i] = [];

for (let j = 0; j < statusResult.length; j++) {
if (_this.tuanGoodsList[i].roomId == statusResult[j].roomId) {
rs[i] = statusResult[j];
break;
}
}
}
_this.goodsAndCalendar = rs;
console.log(_this.goodsAndCalendar);


if (statusResult.length>0) {
_this.loadedLastDate = _this.maxDateInList(statusResult[0].roomStatusList, true);
} else {
_this.loadedLastDate = null;
}
}).catch(function (response) {
console.log(response);
});
},
newDate: function(dateStr) {
let ymd = dateStr.split('-');
return new Date(ymd[0], ymd[1]-1, ymd[2]);
},
maxDateInList: function(statusList, toFindMax) {
if (statusList==null) {
return null;
}
let keys = Object.keys(statusList);
keys.sort(function(d1,d2){
return Date.parse(d1) - Date.parse(d2);
});
if (keys.length>0) {
if (toFindMax==null || toFindMax==true) {
return this.newDate(keys[keys.length-1]);
} else {
return this.newDate(keys[0]);
}
} else {
return null;
}
},
loadMoreCalendar: function (shopId, year, month, day, step) {
let _this = this;
_this.axios.get('/v1/shop/'+shopId+'/status?startTime='+year+'-'+(month+1)+'-'+day+'&step='+step, null, {
headers: {}
}).then(function (response) {
var statusResult = [];
statusResult = response.data.data;

if (statusResult.length==0) {
return;
}

let minDate = _this.maxDateInList(statusResult[0].roomStatusList, false);
if (minDate==null){
return;
}
if (_this.loadedLastDate!=null && minDate<=_this.loadedLastDate) {
return;
}


let keys = Object.keys(statusResult[0].roomStatusList);
keys.sort(function(d1,d2){
return Date.parse(d1) - Date.parse(d2);
});
for (let i=0; i<keys.length; i++){
let d = _this.newDate(keys[i]);
_this.calendar.push({
'year': d.getFullYear(),
'month': (d.getMonth()+1),
'day': d.getDate(),
'week': week[d.getDay()]
});
}


for (let i = 0; i < _this.tuanGoodsList.length; i++){

for (let j = 0; j < statusResult.length; j++) {
if (_this.tuanGoodsList[i].roomId == statusResult[j].roomId) {

for (let k=0; k<keys.length; k++){
_this.goodsAndCalendar[i].roomStatusList[keys[k]] = statusResult[j].roomStatusList[keys[k]];
}
break;
}
}
}


_this.loadedLastDate = _this.newDate( keys[keys.length-1] );
_this.dateGoodsStatusWidth = _this.dateGoodsStatusWidth + keys.length*70 - _this.dateGoodsStatusWidthPad;

}).catch(function (response) {
console.log(response);
});
},
luanchLoad(){
let _this = this;
let shopId = this.$route.params.shopId;
if(_this.loadedLastDate!=null) {
let d = _this.newDate(_this.loadedLastDate.getFullYear()+'-'+(_this.loadedLastDate.getMonth()+1)+'-'+_this.loadedLastDate.getDate());
d.setDate(d.getDate() + 1);
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var step = _this.daysStep;
_this.loadMoreCalendar(shopId, year, month, day, step);
}
},
editStatus(goodsId, status, yearMonthDay, key)
{
console.log(goodsId, status, yearMonthDay, key)
let newStatus = ''
if (status == 'a') {
newStatus = 'b'
} else if (status == 'b') {
newStatus = 'a'
}
let startTime = yearMonthDay
let endTime = yearMonthDay
this.editForm = {'goodsId':goodsId,'status':newStatus,'startTime':startTime,'endTime':endTime, 'keyFather':key, 'keySon':yearMonthDay}
this.statusShow = true

},
onCancel:function () {
this.editForm = null
this.statusShow = false
},
onConfirm:function () {
this.statusShow = false
console.log(this.editForm)
let shopId = this.$route.params.shopId
let goodsId = this.editForm.goodsId
let status = this.editForm.status
let startTime = this.editForm.startTime
let endTime = this.editForm.endTime

_this.axios.get('/v1/shop/'+shopId+'/room/'+goodsId+'/status/setting?status='+status+'&startTime='+startTime+'&endTime='+endTime, null, {
headers: {}
}).then(function (response) {
console.log(response.data);




_this.goodsAndCalendar[_this.editForm.keyFather].roomStatusList[_this.editForm.keySon] = _this.editForm.status
}).catch(function (response) {
console.log(response);
});
}
},
created(){
let shopId = this.$route.params.shopId;

this.initTuanGoodsList(shopId);

this.initShowData(shopId);
},
mounted(){
let _this = this;
let shopId = this.$route.params.shopId;
let _divRight = this.$refs.blockRight;
_divRight.onscroll = function(){
if (window.innerWidth - 80 + _divRight.scrollLeft + 10 >= _divRight.scrollWidth){
console.log('------ åŠ è½½ä¸‹ä¸€é¡?------');
if (_this.loadingMoreLock==true) {
return;
}
_this.loadingMoreLock=true;
setTimeout(function() {
_this.loadingMoreLock=false;
}, 2000);


_this.dateGoodsStatusWidth = _this.dateGoodsStatusWidth + _this.dateGoodsStatusWidthPad;

_divRight.scrollLeft += 30;

if(_this.loadedLastDate!=null) {
let d = _this.newDate(_this.loadedLastDate.getFullYear()+'-'+(_this.loadedLastDate.getMonth()+1)+'-'+_this.loadedLastDate.getDate());
d.setDate(d.getDate() + 1);
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var step = _this.daysStep;
_this.loadMoreCalendar(shopId, year, month, day, step);
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/tuan_goods/GoodStatus.vue